module.exports = __webpack_public_path__ + "static/media/yourspace-open-office-desk-in-center.7af03ffc.jpg";